const MEDIA_TYPE = {
  PHONE: 'phone',
  Pad: 'pad',
  PC: 'pc'
}

function matchEquiment() {
  let appVersion = window.navigator.appVersion
  let isMobile = appVersion.indexOf('Android') > 0 || appVersion.indexOf('iPhone') > 0 || appVersion.indexOf('iPod') > 0
  let isPad = appVersion.indexOf('iPad') > 0
  if (isMobile) {
    return MEDIA_TYPE.PHONE
  } else if (isPad) {
    return MEDIA_TYPE.Pad
  } else {
    return MEDIA_TYPE.PC
  }
}

export {
  matchEquiment
}



// WEBPACK FOOTER //
// ./src/assets/js/matchEquiment.js